import { useCallback } from 'react';

import { type SubscriptionPlan } from '@air/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type TrackViewedCheckoutPageParams = {
  new_plan: SubscriptionPlan;
  plan: SubscriptionPlan;
};

export const useTrackViewedCheckoutPage = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedCheckoutPage = useCallback(
    (params: TrackViewedCheckoutPageParams) => {
      track(`Viewed checkout page`, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackViewedCheckoutPage };
};
